/* Main container */
/* Parent wrapper needed */
.wrapper {
  container-type: inline-size;
  width: 100%;
  cursor: pointer;
}

.heroArticle {
  display: grid;
  grid-template-rows: auto min-content;
  grid-template-columns: 1fr;
  width: 100%;
  height: 231px;
  position: relative;
  border-radius: 8px;
  border: 1px solid #e4e4e4;
  overflow: hidden;
}

.imageContainer {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: var(--cxy-z-index-internal-base);
}

.imageContainer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.contentContainer {
  display: flex;
  flex-direction: column;
  padding: 8px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  z-index: var(--cxy-z-index-internal-top);
  overflow: hidden;
}

.overlay {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(5, 38, 67, 0) 0%, #010d17 99.57%);
  z-index: var(--cxy-z-index-internal-mid);
}

.title {
  color: #011f32;
  font-family: var(--cxy-font-family-sans);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
}

.metadata {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0 0 0;
}

.metadataLeft {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.metadataRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.metadata .mobileTimestamp {
  color: #6b7883;
  font-family: var(--cxy-font-family-sans);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.metadata .desktopTimestamp {
  display: none;
}

.metadata .readTime {
  color: #011f32;
  text-align: right;
  font-family: var(--cxy-font-family-sans);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.metadata .mobileAuthor {
  color: #011f32;
  font-family: 'Public Sans';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.metadata .desktopAuthor {
  display: none;
}

@container (min-width: 480px) {
  .heroArticle {
    height: 335px;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
  }

  .imageContainer {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    height: 100%;
    width: 100%;
  }

  .overlay {
    display: block;
  }

  .contentContainer {
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    align-self: end;
    padding: 16px 32px;
    width: 100%;
    box-sizing: border-box;
  }

  .title {
    color: var(--cxy-color-white);
    font-family: 'Public Sans';
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
  }

  .metadata .desktopTimestamp {
    display: inline-block;
    color: var(--cxy-color-white);
    font-family: 'Public Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
  }

  .metadata .readTime {
    display: none;
  }

  .metadata .mobileTimestamp {
    display: none;
  }

  .metadata .mobileAuthor {
    display: none;
  }

  .metadata .desktopAuthor {
    display: inline-block;
    color: var(--cxy-color-white);
    font-family: 'Public Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 23px;
  }
}
